import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import enAuth from '@/locales/en/auth.json';
import enCommon from '@/locales/en/common.json';
import enDashboard from '@/locales/en/dashboard.json';
import enErrors from '@/locales/en/errors.json';
import enHelp from '@/locales/en/help.json';
import enPhone from '@/locales/en/phone.json';
import enSettings from '@/locales/en/settings.json';
import enStatuses from '@/locales/en/statuses.json';
import enTasks from '@/locales/en/tasks.json';
import ukAuth from '@/locales/uk/auth.json';
import ukCommon from '@/locales/uk/common.json';
import ukDashboard from '@/locales/uk/dashboard.json';
import ukErrors from '@/locales/uk/errors.json';
import ukHelp from '@/locales/uk/help.json';
import ukPhone from '@/locales/uk/phone.json';
import ukSettings from '@/locales/uk/settings.json';
import ukStatuses from '@/locales/uk/statuses.json';
import ukTasks from '@/locales/uk/tasks.json';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'uk',
    supportedLngs: ['uk', 'en'],
    defaultNS: 'common',
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'hermes.lang',
    },
    interpolation: { escapeValue: false },
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        errors: enErrors,
        statuses: enStatuses,
        dashboard: enDashboard,
        tasks: enTasks,
        phone: enPhone,
        settings: enSettings,
        help: enHelp,
      },
      uk: {
        common: ukCommon,
        auth: ukAuth,
        errors: ukErrors,
        statuses: ukStatuses,
        dashboard: ukDashboard,
        tasks: ukTasks,
        phone: ukPhone,
        settings: ukSettings,
        help: ukHelp,
      },
    },
  });

export default i18n;
